import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../../../context/authContext';

export function useRetailerSkillingSheet() {
  const { user } = useAuth();
  const [skills, setSkills] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSkills = async () => {
      const email = user?.email;

      if (!email) {
        setSkills({});
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_ENDPOINT_USERS}/retailer-skills`,
          {
            params: { email },
          },
        );
        setSkills(response.data);
      } catch (err) {
        setError(err);
        console.error('Error fetching retailer skills:', err);
        setSkills({});
      } finally {
        setLoading(false);
      }
    };

    fetchSkills();
  }, [user]);

  return { skills, loading, error };
}
